export default __webpack_public_path__ + "static/optimizing-logistics-operations-3779afdef8a2f68d229265db2dc6a18e.png";